import NavBar from '../components/shared/NavBar';
import Login from '../components/UserPage/Login';
import Footer from '../components/shared/Footer';
const LoginPage = (props) => {

    return (
        <>
            <NavBar/>
            <Login/>
            <Footer/>
        </>
)}

export default LoginPage;